
import { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppRoutes } from './router';

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Don't scroll to top if navigating to products page with partner parameter
    const hasPartnerParam = location.search.includes('partner=');
    if (!hasPartnerParam) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
